import axios from "axios";
// import WhatsappButton from "../Cashier/whatsappButton";
import BonusOffer from "../TransactionCommon/BonusOffer";
import CashierInput from "../../Components/TransactionCommon/CashierInput";
import { useWithdrawBonus } from "../../services/cashier";
import { TOAST_CONFIG } from "../../constants";
import { redeposit } from "../../constants";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { getFormData, validateNumberInput } from "../../utils";
import { WITHDROW_URL } from "../../DataStore/ApiConstant";
import { toast } from "react-toastify";
import TranslatesContent from "../../DataStore/Languages/translatesContent";

import { calculateBonus, calculateTurnover } from "../../utils";

const Redeposit = () => {
  const bonus = useWithdrawBonus();
  const [reBonus, setReBonus] = useState(0);
  const [reTurn, setReTurn] = useState(0);
  const [amount, setAmount] = useState(null);
  const [load, setLoad] = useState(false);
  const [errmsg, setErrmsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");


  const { handleSubmit } = useForm();
  let submitHandler = () => {
    
    setLoad(errmsg);
    let rest = { ...redeposit, redeposit: amount, bank_account: "", amount: 0 };
    axios
      .post(WITHDROW_URL, getFormData(rest))
      .then((resp) => {
        if (resp.data.resp === "done") {
          setSuccessMsg("Redeposit Successfull" || "err");
          setLoad(false);
        } else {
          setErrmsg(resp?.data?.resp);
          setLoad(false);
        }
      })
      .catch((err) => {
        setErrmsg(err);
        setLoad(false);
      });
  };

  let setRedepositBonus = (reAmount) => {
    
    setErrmsg("")
    setSuccessMsg("")
    setAmount(reAmount);
    let bonusRet = calculateBonus(
      reAmount,
      bonus?.data[2]["maxbonus"] || 0,
      bonus?.data[2]["bonusprecent"] || 0
    );
    setReBonus(bonusRet);
    let turnRet = calculateTurnover(
      reAmount,
      bonus?.data[2]["maxbonus"] || 0,
      bonus?.data[2]["turnover"] || 0,
      bonus?.data[2]["bonusprecent"] || 0
    );
    setReTurn(turnRet);
  };

  return (
    <>
      <div
        className="tab-pane fade"
        id="v-pills-redeposit"
        role="tabpanel"
        aria-labelledby="v-pills-redeposit-tab"
      >
      <form onSubmit={handleSubmit(submitHandler)}>
        
        <div className="row d-flex justify-content-center mt-5">
          <div className="col-md-4 mb-3">
            <div className="row">
              <div className="col-12">
                <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                  Redeposit Amount
                </label>
              </div>
              <div className="col-12">
                <input
                  onInput={(e) => validateNumberInput(e.target)}
                  value={amount}
                  type="number"
                  onChange={(e) =>
                    setRedepositBonus(e.target.value)
                  }
                  className="form-control"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex justify-content-center">
          <div className="col-md-8 mb-3">
            <div className="row">
              <div className="col-12 mt-4">
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-12 col-lg-5 bonusResultLeft">
                      <TranslatesContent contentKey="package-name" />{" "}
                      :
                      </div>
                      <div className="col-12 col-lg-7 bonusResultRight">
                        {bonus?.data?.[2]["pkgname"] || "N/A"}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-5 bonusResultLeft">
                      <TranslatesContent contentKey="bonus-amount" />{" "}
                      :
                      </div>
                      <div className="col-12 col-lg-7 bonusResultRight">
                        {reBonus}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-5 bonusResultLeft">
                      <TranslatesContent contentKey="withdrawal-eft-turnover" />{" "}
                      :
                      </div>
                      <div className="col-12 col-lg-7 bonusResultRight">
                        {reTurn}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex justify-content-center">
          <div className="col-md-3 mb-3">
            <div className="row">
              <div className="col-12" style={{ textAlign: "center" }}>
                <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                  Bonus Activation
                </label>
              </div>
              <div className="d-flex justify-content-center">
                <div className="px-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexCheckDefault"
                      name="bonusActivation" // Group radio buttons
                      style={{ padding: 0 }}
                      defaultChecked={true}
                    />
                    <label
                      className="form-check-label mt-1 ms-2"
                      htmlFor="flexCheckDefault"
                    >
                      Yes
                    </label>
                  </div>
                </div>
                <div className="px-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexCheckDefault"
                      name="bonusActivation" // Group radio buttons
                      style={{ padding: 0 }}
                    />
                    <label
                      className="form-check-label mt-1 ms-2"
                      htmlFor="flexCheckChecked"
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            {successMsg && (
                <div style={{ marginTop: "30px" }} className="alert alert-success ">
                  {successMsg}
                </div>
              )}
              {errmsg && (
                <div style={{ marginTop: "30px" }} className="alert alert-danger" >
                  {errmsg}
                </div>
              )}
          </div>
        </div>
        <div className="row d-flex justify-content-center my-5">
          <div className="col-md-4 mb-3">
            <button type="submit" className="btn btn-primary btn-lg w-100">
              {load ? (
                "Confirming"
              ) : (
                "CONFIRM"
              )}
            </button>
          </div>
        </div>
      </form>
      </div>
    </>
  );
};

export default Redeposit;
